import * as React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from '../api/axios';

export function Signup() {
    const [name, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');

    const handleSignUp = async (event) => { 
        event.preventDefault();
        const payload = { user: email,name, email, password, role: 'user' }; 
        try {
            if (password !== confirm_password) {
                console.error('Passwords do not match');
                return;
            }
            const response = await fetch('https://a63e-2405-4802-30-3520-2508-601d-2dd3-3752.ngrok-free.app/signup', { 
            method: 'POST',
            headers: { 
                'Accept': 'application/json',
            }, 
            body: JSON.stringify(payload), }); 
            if (response.ok) { 
                const data = await response.json();
                console.log('Signup successful:', data); 
                // Handle successful Signup (e.g., save token, redirect, etc.) 
            } else {
                console.error('Signup failed:', response.statusText); 
            }
            axios.post('/signup', payload, {
                headers: {
                    'Accept': 'application/json',
                },
            });
        } catch (error) { 
            console.error('An error occurred:', error); 
        } 
    };
    return (
    <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
    {/* <a href="#" className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
        <img className="w-8 h-8 mr-2" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/logo.svg" alt="logo"/>
        Flowbite    
    </a> */}
    <div className="flex w-full h-screen">
        <div className="w-full flex items-center justify-center lg:w-1/2">
            <div className="w-full max-w-md p-10 bg-white rounded-2xl shadow-lg">
                <h1 className="mt-4 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                    Create an account
                </h1>
                <form className="space-y-4 md:space-y-6 mt-8" onSubmit={handleSignUp}>
                    <div>
                        <label htmlFor="name" className="block mb-2 text-lg font-medium text-gray-900 dark:text-white">Your Name</label>
                        <input 
                        type="text" 
                        name="username" 
                        id="username" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        placeholder="Last Name - First Name" 
                        onChange={(e) => setUsername(e.target.value)}
                        required/>
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-2 text-lg font-medium text-gray-900 dark:text-white">Your email</label>
                        <input 
                        type="email" 
                        name="email" 
                        id="email" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        placeholder="name@company.com"
                        onChange={(e) => setEmail(e.target.value)}
                        required=""/>
                    </div>
                    <div>
                        <label htmlFor="password" className="block mb-2 text-lg font-medium text-gray-900 dark:text-white">Password</label>
                        <input 
                        type="password" 
                        name="password" 
                        id="password" 
                        placeholder="••••••••" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={(e) => setPassword(e.target.value)}
                        required=""/>
                    </div>
                    <div>
                        <label htmlFor="confirm-password" className="block mb-2 text-lg font-medium text-gray-900 dark:text-white">Confirm password</label>
                        <input 
                        type="password" 
                        name="confirm-password" 
                        id="confirm-password" 
                        placeholder="••••••••" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required=""/>
                    </div>
                    <div className="flex items-start">
                        <div className="flex items-center h-5">
                        <input id="terms" aria-describedby="terms" type="checkbox" className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800" required=""/>
                        </div>
                        <div className="ml-3 text-sm">
                        <label htmlFor="terms" className="font-light text-gray-500 dark:text-gray-300">I accept the <Link to="#" className="font-medium text-primary-600 hover:underline dark:text-primary-500" >Terms and Conditions</Link></label>
                        </div>
                    </div>
                    <button type="submit" className="w-full text-gray-500 bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
                    <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                        Already have an account? <Link to="/" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</Link>
                    </p>
                </form>
            </div>
        </div>
        <div className="hidden relative lg:flex h-full w-1/2 items-center justify-center bg-gray-200">
            <div className="w-80 h-80 bg-gradient-to-tr from-violet-500 to-pink-500 rounded-full animate-bounce"/>
            <div className="w-full absolute bottom-0 h-1/2 bg-white/10 backdrop-blur-lg"/>
        </div>
    </div>
</div>
    )
}